/**
 * The TokensRoot container
 */
import React from "react";
import PropTypes from "prop-types";
import { Route, Switch } from "react-router-dom";
import Loadable from "react-loadable";
import LoadingContent from "../../components/LoadingContent";

/**
 * TokensRoot container, the landing page for logged in users
 */
const Faq = Loadable({
  loader: () => import(/* webpackChunkName: "Faq" */ "./FaqDetail"),
  loading: () => LoadingContent,
  delay: 600,
  modules: ["Faq"],
});
// Loadable import for FaqCategory container
const FaqCategory = Loadable({
  loader: () =>
    import(/* webpackChunkName: "FaqCategory" */ "./FaqCategoryDetail"),
  loading: () => LoadingContent,
  delay: 600,
  modules: ["FaqCategory"],
});
// Loadable import for SupportCenter container
const SupportCenter = Loadable({
  loader: () =>
    import(/* webpackChunkName: "SupportCenter" */ "./SupportCenter"),
  loading: () => LoadingContent,
  delay: 600,
  modules: ["SupportCenter"],
});
const ProductionData = Loadable({
  loader: () =>
    import(/* webpackChunkName: "ProductionData" */ "./ProductionData"),
  loading: () => LoadingContent,
  delay: 600,
  modules: ["ProductionData"],
});
const SupportContact = Loadable({
  loader: () =>
    import(/* webpackChunkName: "SupportContact" */ "./SupportContact"),
  loading: () => LoadingContent,
  delay: 600,
  modules: ["SupportContact"],
});

const CheckoutRoot = () => {
  return (
    <div>
      <Switch>
        <Route exact path={"/:lang/faqs/"} component={SupportCenter} />
        <Route exact path={"/:lang/fileguide/"} component={ProductionData} />
        <Route exact path={"/:lang/faqs/:slug?"} component={FaqCategory} />
        <Route exact path={"/:lang/faq/:slug?"} component={Faq} />
        <Route exact path={"/:lang/kontakt/"} component={SupportContact} />
      </Switch>
    </div>
  );
};

/**  define proptype for the 'translation' function  */
CheckoutRoot.contextTypes = {
  t: PropTypes.func,
};

/** export the component as redux connected component */
export default CheckoutRoot;
